import env from "./env"

const constants = {
  API_URL: env.API_URL,
  LOCAL_STORAGE: {
    USER: "@onyx::user"
  },
  GOALS: [
    { label: 'Goal', value: 'goal' },
    { label: 'Subgoal', value: 'subgoal' }
  ],
  TYPE_OF_PROGRAMS: [
    'Communication and Counter Narratives',
    'Education Sector',
    'Community Policing',
    'Government and policymaking',
    'Community (Resilience building or disengagement)-Grassroots or NGO',
    'Prison sector (rehabilitation and reintegration)',
    'Psycho-social intervention (mentorship)',
    'Psychologial support or therapy',
    'Women\'s Empowerment or Gender Rights',
    'Religious Community',
    'General Prevention',
    'Conflict resolution',
    'Peace-building or Peacekeeping',
    'Youth Entrepreneurship',
    'Interfaith or intrafaith dialogue',
    'Conflict Mediation (community, state)',
    'Art or Culture',
    'Employment and Job Creation/Training Programs',
    'Sports',
  ],
  AGES: [
    { label: '0-15', value: '0-15' },
    { label: '16-30', value: '16-30' },
    { label: '31-60', value: '31-60' }
  ],
  GENDERS: [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
    { label: 'Both', value: 'both' }
  ],
  ENTRY_POINTS: [
    { label: 'Primary intervention', value: 'primary' },
    { label: 'Secondary intervention', value: 'secondary' },
    { label: 'Tertiary intervention', value: 'tertiary' }
  ],
  STAKEHOLDERS: [
    'Donors',
    'Recipients of the program',
    'Target population',
    'Community',
    'Country-level',
    'Policymakers and lawmakers'
  ],
  FACTORS: [
    'Reduce Risk',
    'Increase Resilience',
    'Both of the options above'
  ],
  TAGS: [
    'art',
    'cnarratives',
    'community',
    'conflict',
    'CVE',
    'design',
    'donor',
    'drivers',
    'economic',
    'edu',
    'ethnic',
    'evaluation',
    'family',
    'female',
    'FTF',
    'govt',
    'health',
    'iedu',
    'intelligence',
    'interfaith',
    'male',
    'military',
    'MME',
    'monitoring',
    'NAP',
    'peace',
    'police',
    'primary',
    'prison',
    'psychology',
    'religion',
    'resilience',
    'risk',
    'secondary',
    'social',
    'sport',
    'tertiary',
    'TOC',
    'vocation',
    'youth'
  ],
  SECTIONS: [
    'Basics',
    'Theory of Change',
    'Goals and Objectives',
    'Activities',
    'Goals and Activities',
    'Indicators',
    'Collection Methods',
    'Resources and Limitations',
    'Projecting Results',
    'Evaluating Results',
    'Actual Results',
  ]
};

export default constants;


// WEBPACK FOOTER //
// ./src/defaults/constants.js